import React, { useEffect, useRef, useState } from 'react';
import { ClockIcon, CircleIcon } from '../Icons/Icons';
import AnimateHeight from 'react-animate-height';
import classnames from 'classnames';

import "./schedulecard.scss";
import TextTranslate from '../TextTranslate/TextTranslate';
import moment from 'moment';

export default function ScheduleCard ({ schedule, lang, ...props }) {

	const [canResize, setCanResize] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const cardRef = useRef();
	const descriptionRef = useRef();

	useEffect(() => {
		if(descriptionRef.current.offsetWidth >= (cardRef.current.offsetWidth - 80)) {
			setCanResize(true)
		}
	}, [schedule])

	return (
		<div
			ref={cardRef}
			className={classnames([
				"schedule-card",
				{ expanded: isOpen || !canResize }
			])}
		>
			<h4>
				{schedule.translations?.name ?
					schedule.translations?.name[lang.id] :
					schedule.name
				}
			</h4>
			<div className="stats">
				<div className="stats__item">
					<ClockIcon />
					<p>{isNaN(schedule.duration) ? schedule.duration : moment.duration(schedule.duration, 'minutes').humanize()}</p>
				</div>
				<div className="stats__item">
					<CircleIcon />
					<p>
						{schedule.translations?.category ?
							schedule.translations?.category[lang.id] :
							schedule.category
						}
					</p>
				</div>
			</div>
			<div className="content">
				<AnimateHeight
					duration={ 250 }
					height={ isOpen ? 'auto' : 22 }
				>
				<p ref={descriptionRef} className="description">
					{schedule.translations?.description ?
						schedule.translations?.description[lang.id] :
						schedule.description
					}
				</p>
				</AnimateHeight>
				{canResize &&
					<a className="link text-secondary" onClick={() => setIsOpen(!isOpen)}>
						{isOpen ?
							<TextTranslate name="word-show-less" fallback="Show Less"/> :
							<TextTranslate name="word-read-more" fallback="Read More"/>
						}
					</a>
				}
			</div>
		</div>
	)
}
